import FacebookAuthorisationButton from '../../components/authorise/platforms/FacebookAuthorisationButton'
import { AccountOnboardingLayout } from '../../containers/AccountOnboardingLayout'

/**
 * This page is used to add a Facebook account to Arwen.
 */
function NewFacebookAccountPage() {
    return (
        <AccountOnboardingLayout title="Add a Facebook Page to Arwen">
            <p className="mb-4">Click below to add a Facebook Page to Arwen.</p>
            <FacebookAuthorisationButton />
        </AccountOnboardingLayout>
    )
}

export default NewFacebookAccountPage
